export const getButtonText = (text: string, counter: number) =>
  `${text}${counter > 0 ? ` (${counter}s)` : ''}`;

export const AUTO_REDIRECTION_TEXT = "If you're not redirected, tap the button";
